import { defineRouteMiddleware, navigateTo } from '@/shared/utils/router.js';
import { useAuthStore } from '#modules/auth/stores/auth.store.js';

export default defineRouteMiddleware(function shouldBeAuthenticated(_to) {
    const authStore = useAuthStore();

    if (!authStore.isAuthenticated) {
        return navigateTo({
            name: 'login',
        });
    }
});
